import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import CustomersList from "../components/Customers/CustomersList";
import EditCustomerDialog from "../components/Customers/EditCustomerDialog";
import ConfirmationDialog from "../components//common/ConfirmationDialog";
import { fetchCustomers, delCustomer } from "../store/customers-actions";

const Customers = () => {
  const customers = useSelector((state) => state.customers.list);
  const isLoading = useSelector((state) => state.ui.customersLoading);

  const dispatch = useDispatch();

  const [selectedId, setSelectedId] = React.useState(null);
  const [isAdding, setIsAdding] = React.useState(false);
  const [isRemove, setIsRemove] = React.useState(false);

  const history = useHistory();

  React.useEffect(() => {
    dispatch(fetchCustomers());
  }, [dispatch]);

  const rowSelectedHandle = (event) => setSelectedId(event.data.id);

  const editButtonHandler = () => {
    history.push(`/customers/${selectedId}`);
  };

  const editDialog = React.useMemo(() => {
    return (
      <EditCustomerDialog open={isAdding} onClose={() => setIsAdding(false)} />
    );
  }, [isAdding]);

  const confirmationDialog = React.useMemo(() => {
    const removeSelectedCustomer = async (id) => dispatch(delCustomer(id));
    return (
      <ConfirmationDialog
        open={isRemove}
        onClose={() => setIsRemove(false)}
        onOk={() => removeSelectedCustomer(selectedId)}
        caption="Please confirm?"
        text="Are you sure you want to completely remove this customer?"
      />
    );
  }, [isRemove, selectedId, dispatch]);

  return (
    <>
      {editDialog}
      {confirmationDialog}
      <CustomersList
        isLoading={isLoading}
        rows={customers}
        selectedId={selectedId}
        onAdd={() => setIsAdding(true)}
        onEdit={editButtonHandler}
        onDelete={() => setIsRemove(true)}
        onRowSelected={rowSelectedHandle}
      />
    </>
  );
};
export default Customers;
